import { createStructuredSelector } from 'reselect';
import { getFirstName, getLastName, getThumbnail } from './auth';
import { getIconicSubscriptionUIDs, getIsPlusEnrolled } from './subscription';

const physicalNotesRelatedInfoSelector = createStructuredSelector({
  firstName: getFirstName,
  lastName: getLastName,
  thumbnail: getThumbnail,
  isPlusEnrolled: getIsPlusEnrolled,
  iconicSubscriptionUIDs: getIconicSubscriptionUIDs
});

export default physicalNotesRelatedInfoSelector;
